export const getStoredPreference = (key: string) => {
  return localStorage?.getItem(key) === 'true';
};
